import './menu_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  open () {
    this.element.classList.add('menu--opened')
    this.bodyElement.classList.add('body--open_menu')
  }

  close () {
    this.element.classList.remove('menu--opened')
    this.bodyElement.classList.remove('body--open_menu')
  }

  get bodyElement () {
    return document.body
  }

  get id () {
    return this.data.get('id')
  }
}
